export default {
    locale: "ru",
    maxItemsInCart: 1000,
};

export const api_key = "too3qree222oes6eljal4toa7go3be9ed80hifbl8jh0r9ty";
